import ColourCheckbox from '~/components/ColourCheckbox';
import Tracked from '~/components/Tracked';
import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import type { MenuItemProps } from '../types';

interface MegaNavCategoryListProps {
  ancestorLabels?: string[];
  children: Array<MenuItemProps>;
  hideTrailingSlash?: boolean;
  parentLink: string;
  title: string;
}

export default function MegaNavCategoryList({
  title,
  children,
  parentLink,
  hideTrailingSlash = false,
  ancestorLabels = [title]
}: MegaNavCategoryListProps) {
  const fireNavigationLink = useNavigationLinkInteraction('meganav');

  return (
    <div className="flex flex-col">
      <div className="flex h-[29px] items-center pt-[3px] text-[16px] font-bold text-black">
        {title}
      </div>
      {title !== 'Colour' &&
        children.map((item, i) => (
          <Tracked.ExternalLink
            href={`${parentLink}/${item.slug}/`}
            className="h-[29px] py-[3px] text-[13px] font-normal text-grey-read"
            key={`${parentLink}/${item.slug}/`}
            name={item.name as TrackedButtonClickName}
            variant="none"
            pagePosition="Header"
            onClick={() =>
              fireNavigationLink(`${parentLink}/${item.slug}/`, i + 1, {
                ancestorLabels,
                label: item.name
              })
            }
          >
            {item.name}
          </Tracked.ExternalLink>
        ))}
      {title === 'Colour' && (
        <div className="grid grid-cols-3">
          {children.map((item, i) => {
            const href = `${parentLink}/${item.slug}${!hideTrailingSlash ? '/' : ''}`;

            return (
              <Tracked.ExternalLink
                href={href}
                className="h-[29px] py-[3px] text-[13px] font-normal text-grey-read"
                key={`${parentLink}/${item.slug}/`}
                name={item.name as TrackedButtonClickName}
                variant="none"
                pagePosition="Header"
                onClick={() =>
                  fireNavigationLink(href, i + 1, {
                    ancestorLabels,
                    label: item.name
                  })
                }
              >
                <div className="mr-[10px] mt-[5px]">
                  <ColourCheckbox isRefined={false} fill={item.colour} />
                </div>
                {item.name}
              </Tracked.ExternalLink>
            );
          })}
        </div>
      )}
    </div>
  );
}
